import LandingZones from './LandingZones'
import Shots from './Shots'
import Topography from './Topography'

export default {
  LandingZones,
  Shots,
  Topography,
}
